/**
 * Define the mutation types available in the application
 *
 * Can be used to get an overview of where a mutation is coming from
 * and what is available to use. Along with this, duplicate commit message
 * names will be immediately obvious
 */

// admin
export const SET_FOUND_USERNAMES = 'SET_FOUND_USERNAMES'
export const SET_USERNAME_SELECTED = 'SET_USERNAME_SELECTED'

// billing
export const SET_BILLING = 'SET_BILLING'
export const SET_AMOUNT_DUE = 'SET_AMOUNT_DUE'
export const SET_DUE_DATE = 'SET_DUE_DATE'
export const SET_OVERDUE = 'SET_OVERDUE'
export const SET_BILLS = 'SET_BILLS'
export const SET_BILL_PAGE = 'SET_BILL_PAGE'
export const SET_PAYMENTS = 'SET_PAYMENTS'
export const SET_TEMP_PAYMENT_ID = 'SET_TEMP_PAYMENT_ID'
export const SET_PAYMENT_ACCOUNTS = 'SET_PAYMENT_ACCOUNTS'
export const START_PAYMENT_REQUEST = 'START_PAYMENT_REQUEST'
export const END_PAYMENT_REQUEST = 'END_PAYMENT_REQUEST'
export const SET_BILLING_ADDRESS = 'SET_BILLING_ADDRESS'
export const SET_PAYA_URL = 'SET_PAYA_URL'


// contacts
export const SET_AUTHORIZED_CONTACTS = 'SET_AUTHORIZED_CONTACTS'
export const SET_EDITING_CONTACT = 'SET_EDITING_CONTACT'
export const SET_EDITING_LDAP = 'SET_EDITING_LDAP'
export const SET_EDITING_PERMS = 'SET_EDITING_PERMS'
export const BEGIN_EDIT_CONTACT = 'BEGIN_EDIT_CONTACT'
export const CANCEL_EDIT_CONTACT = 'CANCEL_EDIT_CONTACT'
export const UPDATE_EDITING_CONTACT = 'UPDATE_EDITING_CONTACT'
export const UPDATE_NEW_CONTACT = 'UPDATE_NEW_CONTACT'

// user
export const LOGGED_IN = 'LOGGED_IN'
export const SET_LOGGED_IN = 'SET_LOGGED_IN'
export const LOGGED_OUT = 'LOGGED_OUT'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_USER = 'SET_USER'
export const SET_PERM_SCHEMA = 'SET_PERM_SCHEMA'
export const SET_PERM_CATEGORIES = 'SET_PERM_CATEGORIES'
export const SAVE_AJAX_REQUEST = 'SAVE_AJAX_REQUEST'
export const CLEAR_AJAX_REQUEST = 'CLEAR_AJAX_REQUEST'
export const SET_PASSWORD_WORDLIST = 'SET_PASSWORD_WORDLIST'
export const HAS_DARK_THEME = 'HAS_DARK_THEME'

// DNS
export const GET_ZONES = 'GET_ZONES'
export const SET_DEFAULT_ACTIVE_ZONE = 'SET_DEFAULT_ACTIVE_ZONE'
export const SET_ACTIVE_ZONE = 'SET_ACTIVE_ZONE'
export const SET_EDITING_ZONE_ALIASES = 'SET_EDITING_ZONE_ALIASES'
export const UPDATE_EDITING_ZONE = 'UPDATE_EDITING_ZONE'
export const BEGIN_CREATING_ALIAS = 'BEGIN_CREATING_ALIAS'
export const END_CREATING_ALIAS = 'END_CREATING_ALIAS'
export const UPDATE_NEW_ZONE = 'UPDATE_NEW_ZONE'
export const SET_NEW_ZONE = 'SET_NEW_ZONE'
export const SET_RECORDS = 'SET_RECORDS'
export const NULL_ACTIVE_ZONE = 'NULL_ACTIVE_ZONE'
export const SET_EDITING_ZONE = 'SET_EDITING_ZONE'
export const NEXT_ZONES_PAGE = 'NEXT_ZONES_PAGE'
export const PREV_ZONES_PAGE = 'PREV_ZONES_PAGE'
export const NEXT_RECORDS_PAGE = 'NEXT_RECORDS_PAGE'
export const PREV_RECORDS_PAGE = 'PREV_RECORDS_PAGE'
export const FIRST_RECORDS_PAGE = 'FIRST_RECORDS_PAGE'
export const RESET_DISABLED_ZONE_TIMERS = 'RESET_DISABLED_ZONE_TIMERS'
export const ZONE_REFRESH_TIMERS_LOADED = 'ZONE_REFRESH_TIMERS_LOADED'
export const NEW_ZONE_ADDED = 'NEW_ZONE_ADDED'
export const INCREASE_STARTUP_DISABLED_ZONE = 'INCREASE_STARTUP_DISABLED_ZONE'
export const REMOVE_DISABLED_ZONE_BY_INDEX = 'REMOVE_DISABLED_ZONE_BY_INDEX'
export const TOGGLE_SHOW_ALL_RECORDS = 'TOGGLE_SHOW_ALL_RECORDS'
export const TOGGLE_SHOW_ALL_ZONES = 'TOGGLE_SHOW_ALL_ZONES'

// Notifications
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const ADD_NOTIFICATION_TIMEOUT = 'ADD_NOTIFICATION_TIMEOUT'
export const ADD_NOTIFICATION_FROM_RESULT = 'ADD_NOTIFICATION_FROM_RESULT'
export const UNHANDLED_ERROR_NOTIFICATION = 'UNHANDLED_ERROR_NOTIFICATION'
export const ACCESS_DENIED_NOTIFICATION = 'ACCESS_DENIED_NOTIFICATION'
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION'
export const HIDE_ALL_NOTIFICATIONS = 'HIDE_ALL_NOTIFICATIONS'
export const ADD_MODAL_NOTIFICATION = 'ADD_MODAL_NOTIFICATION'
export const ADD_MODAL_NOTIFICATION_FROM_RESULT = 'ADD_MODAL_NOTIFICATION_FROM_RESULT'
export const ADD_UNHANDLED_MODAL_NOTIFICATION = 'ADD_UNHANDLED_MODAL_NOTIFICATION'
export const HIDE_MODAL_NOTIFICATION = 'HIDE_MODAL_NOTIFICATION'
export const HIDE_ALL_MODAL_NOTIFICATIONS = 'HIDE_ALL_MODAL_NOTIFICATIONS'
export const SHOW_LOGOUT_NOTIFICATION = 'SHOW_LOGOUT_NOTIFICATION'
export const HIDE_LOGOUT_NOTIFICATION = 'HIDE_LOGOUT_NOTIFICATION'

// Hosting
export const CREATING_HOSTING = 'CREATING_HOSTING'
export const FINISHED_CREATING_HOSTING = 'FINISHED_CREATING_HOSTING'
export const DELETING_HOSTING = 'DELETING_HOSTING'
export const FINISHED_DELETING_HOSTING = 'FINISHED_DELETING_HOSTING'

// Servers
export const ADD_SERVER = 'ADD_SERVER'
export const SET_SERVERS = 'SET_SERVERS'
export const SET_SERVER = 'SET_SERVER'
export const SET_SERVER_STATUS = 'SET_SERVER_STATUS'
export const INCREASE_LAST_SHUTDOWN = 'INCREASE_LAST_SHUTDOWN'
export const SET_VIEWING_SERVER_IID = 'SET_VIEWING_SERVER_IID'
export const UPDATE_EDITING_SERVER = 'UPDATE_EDITING_SERVER'
export const SET_SSL_CERTS = 'SET_SSL_CERTS'
export const SET_DATABASES = 'SET_DATABASES'
export const SET_VHOSTS = 'SET_VHOSTS'
export const SET_FTP_USERS = 'SET_FTP_USERS'
export const SET_DOMAIN_REDIRECTS = 'SET_DOMAIN_REDIRECTS'
export const SET_PHP_SETTINGS = 'SET_PHP_SETTINGS'
export const SET_NGINX_STATUS = 'SET_NGINX_STATUS'
export const SERVER_REFRESH_TIMERS_LOADED = 'SERVER_REFRESH_TIMERS_LOADED'
export const RESET_SERVER_REFRESH_TIMERS = 'RESET_SERVER_REFRESH_TIMERS'
export const SET_EDITING_DB = 'SET_EDITING_DB'
export const SET_UPDATE_FTP = 'SET_UPDATE_FTP'
export const SET_NEW_FTP_VHOST_ID = 'SET_NEW_FTP_VHOST_ID'
export const SET_EDITING_SERVER = 'SET_EDITING_SERVER'
export const CREATING_SERVER = 'CREATING_SERVER'
export const FINISHED_CREATING_SERVER = 'FINISHED_CREATING_SERVER'
export const UPDATING_SERVER = 'UPDATING_SERVER'
export const FINISHED_UPDATING_SERVER = 'FINISHED_UPDATING_SERVER'
export const DELETING_SERVER = 'DELETING_SERVER'
export const FINISHED_DELETING_SERVER = 'FINISHED_DELETING_SERVER'
export const DATABASE_REFRESH_TIMERS_LOADED = 'DATABASE_REFRESH_TIMERS_LOADED'
export const RESET_DATABASE_TIMERS = 'RESET_DATABASE_TIMERS'
export const NEW_DATABASE_CREATED = 'NEW_DATABASE_CREATED'
export const SET_DATABASE_BY_INDEX = 'SET_DATABASE_BY_INDEX'
export const REMOVE_DATABASE_BY_INDEX = 'REMOVE_DATABASE_BY_INDEX'
export const VHOST_REFRESH_TIMERS_LOADED = 'VHOST_REFRESH_TIMERS_LOADED'
export const RESET_VHOST_TIMERS = 'RESET_VHOST_TIMERS'
export const NEW_VHOST_CREATED = 'NEW_VHOST_CREATED'
export const SET_NEW_VHOST_BY_INDEX = 'SET_NEW_VHOST_BY_INDEX'
export const REMOVE_NEW_VHOST_BY_INDEX = 'REMOVE_NEW_VHOST_BY_INDEX'
export const INCREASE_STARTUP_NEW_VHOST = 'INCREASE_STARTUP_NEW_VHOST'
export const INCREASE_STARTUP_NEW_DATABASE = 'INCREASE_STARTUP_NEW_DATABASE'
export const SET_ALL_SERVERS = 'SET_ALL_SERVERS'
export const SET_ALL_SERVERS_COUNT = 'SET_ALL_SERVERS_COUNT'

// Services
export const ADD_COLOCATIONS = 'ADD_COLOCATIONS'
export const ADD_CONNECTIVITY = 'ADD_CONNECTIVITY'
export const ADD_EMAILS = 'ADD_EMAILS'
export const ADD_HOSTING = 'ADD_HOSTING'
export const ADD_DOMAINS = 'ADD_DOMAINS'
export const SET_RESIDENTIAL_EMAILS = 'SET_RESIDENTIAL_EMAILS'
export const SET_BUSINESS_EMAILS = 'SET_BUSINESS_EMAILS'
export const SET_EMAIL_ALIASES = 'SET_EMAIL_ALIASES'
export const SET_PLESK_SERVERS = 'SET_PLESK_SERVERS'
export const SET_SSL = 'SET_SSL'
export const ADD_VOIP = 'ADD_VOIP'
export const OPEN_ALL_SERVICE_PANELS = 'OPEN_ALL_SERVICE_PANELS'
export const CLOSE_ALL_BUT_ONE_SERVICE_PANEL = 'CLOSE_ALL_BUT_ONE_SERVICE_PANEL'
export const CLOSE_ALL_SERVICE_PANELS = 'CLOSE_ALL_SERVICE_PANELS'
export const TOGGLE_SERVICE_PANEL = 'TOGGLE_SERVICE_PANEL'
export const OPEN_SERVICE_PANEL = 'OPEN_SERVICE_PANEL'
export const CLOSE_SERVICE_PANEL = 'CLOSE_SERVICE_PANEL'
export const SET_PROVISION_TASKS = 'SET_PROVISION_TASKS'


// Notices
export const SET_NOTICES = 'SET_NOTICES'
export const SET_ALL_NOTICES = 'SET_ALL_NOTICES'
export const REMOVE_NOTICE = 'REMOVE_NOTICE'


// Modals
export const OPEN_REFRESH_PASSWORD = 'OPEN_REFRESH_PASSWORD'
export const CLOSE_REFRESH_PASSWORD = 'CLOSE_REFRESH_PASSWORD'

// Cart
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const CALCULATE_CART = 'CALCULATE_CART'
export const EMPTY_CART = 'EMPTY_CART'
export const SET_PROVIDER_ORDER = 'SET_PROVIDER_ORDER'
export const SET_SERVICE_CLASS_ORDER = 'SET_SERVICE_CLASS_ORDER'
export const SET_BILLABLE_ITEM_TYPE_ORDER = 'SET_BILLABLE_ITEM_TYPE_ORDER'

// Self Signup
export const SELF_SIGNUP_INITIALIZE_CONNECTIVITY_CLOT = 'SELF_SIGNUP_INITIALIZE_CONNECTIVITY_CLOT'
export const SELF_SIGNUP_CONNECTIVITY_SET_CUSTOMER = 'SELF_SIGNUP_CONNECTIVITY_SET_CUSTOMER'
export const SELF_SIGNUP_CONNECTIVITY_SET_SPEED = 'SELF_SIGNUP_CONNECTIVITY_SET_SPEED'
export const SELF_SIGNUP_CONNECTIVITY_SET_ROUTER = 'SELF_SIGNUP_CONNECTIVITY_SET_ROUTER'
export const SELF_SIGNUP_CONNECTIVITY_SET_UTOPIA = 'SELF_SIGNUP_CONNECTIVITY_SET_UTOPIA'
export const SELF_SIGNUP_CONNECTIVITY_SET_STRATA = 'SELF_SIGNUP_CONNECTIVITY_SET_STRATA'
export const SELF_SIGNUP_CONNECTIVITY_SET_SOUTHERN_UTE = 'SELF_SIGNUP_CONNECTIVITY_SET_SOUTHERN_UTE'
export const SELF_SIGNUP_CONNECTIVITY_SET_VOICE = 'SELF_SIGNUP_CONNECTIVITY_SET_VOICE'
export const SELF_SIGNUP_SET_ATTRIBUTION_DATA = 'SELF_SIGNUP_SET_ATTRIBUTION_DATA'
export const SELF_SIGNUP_SET_CUSTOMER_DATA = 'SELF_SIGNUP_SET_CUSTOMER_DATA'
export const SELF_SIGNUP_SET_PAYMENT_DATA = 'SELF_SIGNUP_SET_PAYMENT_DATA'
export const SELF_SIGNUP_SET_AGREEMENT_DATA = 'SELF_SIGNUP_SET_AGREEMENT_DATA'
export const SELF_SIGNUP_RESET_OUTPUT_MODELS = 'SELF_SIGNUP_RESET_OUTPUT_MODELS'
export const SELF_SIGNUP_SET_INIT_VALUES = 'SELF_SIGNUP_SET_INIT_VALUES'

// Logger
export const SET_PRODUCTION_LOG_LEVEL = 'SET_PRODUCTION_LOG_LEVEL'
export const SET_DEVELOPMENT_LOG_LEVEL = 'SET_DEVELOPMENT_LOG_LEVEL'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js